import { cn } from '@/utils/styles';

export type DividerProps = {
  className?: string;
};

const Divider = ({ className }: DividerProps) => <div className={cn('border-t border-primary', className)} />;

export default Divider;
